import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";
import intl from "react-intl-universal";

import { formatCurrencyAmount, getMovementKindMeta } from "../constants";

const DetailRow = ({ label, value }) => (
  <div>
    <p className="text-xs font-medium text-gray-500">{label}</p>
    <p className="mt-1 text-sm font-semibold text-brand-dark dark:text-gray-100">{value || "—"}</p>
  </div>
);

export const ContaInternacionalMovementDetailModal = ({ open, onClose, item }) => {
  if (!item) return null;

  const kindMeta = getMovementKindMeta()[item.kind];
  const amountLabel = item.amount >= 0
    ? `+${formatCurrencyAmount(Math.abs(item.amount), item.currency)}`
    : `-${formatCurrencyAmount(Math.abs(item.amount), item.currency)}`;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className="!flex !items-center !justify-between !pr-12 !text-base !font-bold !text-brand-dark">
        {intl.get("common.details")}
        <IconButton aria-label={intl.get("common.close")} onClick={onClose} size="small" className="!absolute !right-2 !top-2">
          <MdClose />
        </IconButton>
      </DialogTitle>

      <DialogContent className="!pt-2">
        <div className="space-y-4">
          <DetailRow label={intl.get("grid.movement")} value={kindMeta?.label} />
          <DetailRow label={intl.get("grid.date")} value={item.date} />
          <DetailRow label="Descrição" value={item.description} />
          <DetailRow label={intl.get("grid.value")} value={amountLabel} />
          <DetailRow label={intl.get("grid.status")} value={item.status} />
          {item.counterCurrency && (
            <DetailRow
              label="Contrapartida"
              value={formatCurrencyAmount(item.counterAmount, item.counterCurrency)}
            />
          )}
        </div>
      </DialogContent>

      <DialogActions className="!px-6 !pb-4">
        <button type="button" className="btn-primary" onClick={onClose}>
          {intl.get("common.close")}
        </button>
      </DialogActions>
    </Dialog>
  );
};
